import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Button, Paper } from '@material-ui/core';
import DotIcon from '@material-ui/icons/Lens';
import { truckStatusTime } from '../../../utils/truckStatusTime';

import commonStyles from '../../common/common.module.css';

import Moment from 'moment';

import PickupOrderFwd from '../../../models/PickupOrderFwd';

const styles = (theme: Theme) =>

  createStyles({
    green: {
      color: 'green',
      fontSize: '14px'
    },
    red: {
      color: 'red',
      fontSize: '14px'
    },
    yellow: {
      color: 'orange',
      fontSize: '14px'
    },
    label: {
      fontSize: '11px',
      color: 'var(--primaryblue)',
      fontWeight: 500,
      paddingBottom: '1px',
    },
    containedSizeSmall: {
      padding: '0px 8px',
      textTransform: 'capitalize',
    },
    tableButton: {
      borderRadius: '4px',
      cursor: 'pointer',
      textAlign: 'center',
      display: 'inline-block',
      margin: 0,
      marginLeft: '10px',
      lineHeight: '1.4',
      boxShadow: 'none',
    }
  });

const PADDING_RIGHT = '14px';
const PADDING_LEFT = '14px';
const cellStyle = { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT };
const headerStyle = { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT };


interface FwdOrdersTableProps {
  classes: any;
  pickupOrders: Array<PickupOrderFwd>;
  linkPoDetails: (number: string) => void;
  handleOpenPodModal: (orderNumber: string) => void;
  type: string;
  openModal: Function;
  history?: any; handleOpenModalManualEntry?: () => void;
  handleConvertToPo?: (poNumber: string) => void;
};

  const FwdOrdersTable = (props: FwdOrdersTableProps) => {

    const { classes, pickupOrders } = props;
    const orderColumnTitle: string = props.type === 'po' ? 'Pick Up Order' : props.type === 'go' ? 'Government Order' : 'Drop Off Order';
    const timeColumnTitle: string = props.type === 'po' ? 'Pick Up Date & Time' : 'Drop Off Date & Time';
    const portColumnTitle: string = props.type === 'po' ? 'Arr Port' : 'Dep Port';

    return (


    <div className={commonStyles.wrapper}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h1 className={commonStyles.header} style={{ marginBottom: 0 }}>Orders</h1>
        {props.type === 'go' && props.history && (
          <Button variant="contained" color="primary" onClick={() => props.handleOpenModalManualEntry && props.handleOpenModalManualEntry()}>
            Create GO Order
          </Button>
        )}
      </div>
      <MaterialTable

        components={{ Container: props => <Paper {...props} elevation={0} className={commonStyles.paperTable} /> }}

        data={pickupOrders}

        columns={[
          {
            title: orderColumnTitle, field: '', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingRight: PADDING_RIGHT }, headerStyle: { paddingRight: PADDING_RIGHT },
            render: (rowData: PickupOrderFwd) => {

              return <div>
                <span onClick={() => props.linkPoDetails(rowData.number)}>{rowData.number}</span>
                {rowData.suspended && <Button variant='contained' size='small'
                  className={commonStyles.tableButton}
                  classes={{
                    root: classes.tableButton,
                    containedSizeSmall: classes.containedSizeSmall,
                    label: classes.label
                  }}
                  onClick={() => props.openModal(rowData)} >
                  Cancel Order
                </Button>}
              </div>;

            }
          },
          {
            title: timeColumnTitle, field: '', cellStyle, headerStyle,
            render: (rowData: PickupOrderFwd) => {

              const date: string = Moment(rowData.pickup_date).format('DD MMM YYYY').toUpperCase();
              const time: string | null = rowData.latest_eta;
              const timeFormated: string = time ? '/ ' + time.substring(0, 2) + ':' + time.substring(2) : '';

              return `${date} ${timeFormated}`;
            }
          },
          ...(props.type !== 'go' ? [{ title: portColumnTitle, field: 'port', cellStyle, headerStyle }] : []),
          ...(props.type !== 'go' ? [{ title: 'GHA', field: 'gha_company_name', cellStyle, headerStyle }] : []),
          { title: 'Trucker', field: 'delivery_company_name', cellStyle, headerStyle },
          { title: 'FWD User', field: 'forwarder_user_name', cellStyle, headerStyle },
          { title: 'No AWBs', field: 'num_awbs', cellStyle, headerStyle },
          {
            title: 'Status', field: '', cellStyle: { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT, textAlign: 'center' }, headerStyle: { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT, textAlign: 'center' },
            render: (rowData: PickupOrderFwd) => {
              const colorClass: any = rowData.suspended ? classes.yellow : classes[rowData.color_status];
              return (
                <DotIcon className={colorClass} />
              )
            },
          },
          {
            title: 'Truck Status', field: '',
            render: (rowData: PickupOrderFwd) => {
              const statusText = truckStatusTime(rowData);
              const isGoDeliveredToCustoms =
                rowData.order_type === 'go' &&
                rowData.truck_status &&
                rowData.truck_status.type === 0;

              if (isGoDeliveredToCustoms) {
                return (
                  <span>
                    {statusText}{' '}
                    <span
                      style={{ color: '#003261', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => props.handleOpenPodModal(rowData.number)}
                    >
                      PoD
                    </span>
                  </span>
                );
              }

              return statusText;
            }
          }
        ]}

        options={{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
};

export default withStyles(styles)(FwdOrdersTable);